require("./science.v1");

module.exports = science;
